<div class="categories-dialog">
  <div class="header">
    <div class="text_heading-6">{{ 'components.lpCategoriesDialog.labels.title' | translate }}</div>
    <div>{{ 'components.lpCategoriesDialog.labels.subTitle' | translate }}</div>
  </div>

  <div [class.tui-skeleton]="loading" class="body">
    <lp-category-cell
      *ngFor="let category of categories"
      [selected]="isCategorySelected(category)"
      [category]="category"
      [readonly]="selectedCategories.length === maxCategories && !isCategorySelected(category)"
      (click)="clickCategory(category)"
    ></lp-category-cell>
  </div>

  <div class="footer">
    <button tuiButton type="button" appearance="secondary" (click)="complete()">
      {{ 'common.buttons.cancel' | translate }}
    </button>
    <button tuiButton type="button" [disabled]="loading" (click)="save()">
      {{ 'common.buttons.save' | translate }}
    </button>
  </div>
</div>
